import * as serializer from 'basic-editor-value-serializer';

const {
  types,
  blockLevelElements,
  voidElements,
  textElements,
  indentationChildren
} = serializer;

export default types;

export {
  blockLevelElements,
  voidElements,
  textElements,
  indentationChildren
};

console.log(voidElements);